module.exports = __webpack_public_path__ + "static/media/ViewPreviousPlans.1f651a1d.svg";